import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import { PersonalisationDisplayDetails } from 'ctp-personalisation-search';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceAssociation',
  props: {
  persoDetails: {
    type: Object as PropType<PersonalisationDisplayDetails>,
    default: () => ({})
  }
},
  setup(__props) {

const props = __props;



const hasTrailer = computed(() => (props.persoDetails.vehicleInfo?.vehicleAxles?.vehicleAxlesNumber?.numberOfAxles?.trailerAxles && props.persoDetails.vehicleInfo?.vehicleAxles?.vehicleAxlesNumber?.numberOfAxles?.trailerAxles > 0 ? 'Yes' : 'No'));


return { __sfc: true,props, hasTrailer }
}

})